export interface MarketingConsentOptions {
  isSmsConsentRegistrationEnabled: boolean;
  consentTemplateId: number | null;
  marketingConsentText: string;
  countriesRequiringConsent: string[];
}

export class MarketingConsent {
  isSmsConsentRegistrationEnabled: boolean;
  consentTemplateId: number | null;
  marketingConsentText: string;
  countriesRequiringConsent: string[];

  public constructor(options: MarketingConsentOptions) {
    this.isSmsConsentRegistrationEnabled =
      options.isSmsConsentRegistrationEnabled;
    this.consentTemplateId = options.consentTemplateId;
    this.marketingConsentText = options.marketingConsentText;
    this.countriesRequiringConsent = options.countriesRequiringConsent;
  }

  public isSmsConsentEnabled(): boolean {
    return (
      this.isSmsConsentRegistrationEnabled && this.consentTemplateId !== null
    );
  }

  public doesCountryRequireConsent(countryCode: string): boolean {
    return this.isSmsConsentEnabled()
      ? this.countriesRequiringConsent.includes(countryCode)
      : false;
  }

  public static Default = new MarketingConsent({
    isSmsConsentRegistrationEnabled: false,
    consentTemplateId: null,
    marketingConsentText: '',
    countriesRequiringConsent: [],
  });
}
